var map = {
	"./airport-departure-1280.webp": 4867,
	"./airport-departure-2000.webp": 3558,
	"./airport-departure-640.webp": 2426,
	"./competition-coding-1280.webp": 4751,
	"./competition-coding-2000.webp": 6482,
	"./competition-coding-640.webp": 5902,
	"./competition-day-1280.webp": 589,
	"./competition-day-2000.webp": 2616,
	"./competition-day-640.webp": 9240,
	"./competition-focus-1280.webp": 4103,
	"./competition-focus-2000.webp": 7994,
	"./competition-focus-640.webp": 4406,
	"./competition-workstation-1280.webp": 3642,
	"./competition-workstation-2000.webp": 883,
	"./competition-workstation-640.webp": 4421,
	"./competitors-exchange-1280.webp": 1354,
	"./competitors-exchange-2000.webp": 3619,
	"./competitors-exchange-640.webp": 2549,
	"./delegation-arrival-1280.webp": 501,
	"./delegation-arrival-640.webp": 4368,
	"./huangpu-river-skyline-1280.webp": 5648,
	"./huangpu-river-skyline-2000.webp": 5721,
	"./huangpu-river-skyline-640.webp": 8215,
	"./huangpu-river-team-1280.webp": 7072,
	"./huangpu-river-team-640.webp": 9191,
	"./opening-ceremony-1280.webp": 9274,
	"./opening-ceremony-1600.webp": 8206,
	"./opening-ceremony-640.webp": 4853,
	"./opening-ceremony-flag-1280.webp": 2237,
	"./opening-ceremony-flag-1600.webp": 1313,
	"./opening-ceremony-flag-640.webp": 6072,
	"./team-arrival-1280.webp": 4184,
	"./team-arrival-640.webp": 1631,
	"./team-arrival-wide-1280.webp": 216,
	"./team-arrival-wide-640.webp": 6015,
	"./team-bus-to-venue-1280.webp": 5435,
	"./team-bus-to-venue-640.webp": 6738,
	"./team-flag-night-1280.webp": 2754,
	"./team-flag-night-640.webp": 4189,
	"./team-selfie-flag-1280.webp": 9220,
	"./team-selfie-flag-640.webp": 6195,
	"./team-venue-1280.webp": 4658,
	"./team-venue-2000.webp": 2075,
	"./team-venue-640.webp": 6621,
	"./traditional-dress-backstage-1280.webp": 9810,
	"./traditional-dress-backstage-640.webp": 7213,
	"./traditional-dress-stairs-1280.webp": 8955,
	"./traditional-dress-stairs-1600.webp": 1615,
	"./traditional-dress-stairs-640.webp": 8994,
	"./traditional-dress-team-1280.webp": 1605,
	"./traditional-dress-team-640.webp": 765,
	"./web-technologies-competitors-1280.webp": 3668,
	"./web-technologies-competitors-2000.webp": 7517,
	"./web-technologies-competitors-640.webp": 9475,
	"./web-technologies-hall-1280.webp": 8386,
	"./web-technologies-hall-2000.webp": 1819,
	"./web-technologies-hall-640.webp": 3805,
	"./workstation-review-1280.webp": 8901,
	"./workstation-review-2000.webp": 176,
	"./workstation-review-640.webp": 2368,
	"./worldskills-shanghai-sign-1280.webp": 791,
	"./worldskills-shanghai-sign-2000.webp": 8330,
	"./worldskills-shanghai-sign-640.webp": 9958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8671;